export default "__VITE_ASSET__VFldXz20__"